var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items)?_c('IconBtn',{attrs:{"title":"CSV","icon":"mdi-download"},on:{"click":function($event){return _vm.download()}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }